export default function PrefetchErrorView() {
    // Using empty error view because the PrefetchExecutor is an invisible React
    // tree that is used solely to execute prefetch requests.
    return null;
}

//# sourceMappingURL=PrefetchErrorView.js.map